/**
 * Una URL que escribió un club, lista para un `href`, o `undefined`.
 *
 * El servidor ya solo acepta `https://` en esos campos (`external_url`,
 * `external_album_url`), pero un `href` con `javascript:` ejecuta código en el
 * panel de quien lo pulse: si mañana un campo nuevo se valida peor, este es el
 * último sitio donde pararlo. Sin `href`, el enlace no lleva a ninguna parte.
 */
export function enlaceSeguro(
  url: string | null | undefined
): string | undefined {
  if (!url) return undefined;
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:'
      ? u.toString()
      : undefined;
  } catch {
    return undefined;
  }
}
